import { Apple, Play } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { APP_STORE_URL, GOOGLE_PLAY_URL } from "../config";

const APP_IMG =
    "https://images.unsplash.com/photo-1758272420784-99756078bd43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxzdHlsaXNoJTIwbW9iaWxlJTIwc21hcnRwaG9uZSUyMGZhc2hpb258ZW58MHx8fHwxNzg2ODcxODE5fDA&ixlib=rb-4.1.0&q=85";

const StoreButton = ({ href, testId, icon: Icon, top, bottom }) => (
    <a
        href={href}
        data-testid={testId}
        className="group inline-flex items-center gap-3 px-6 py-3.5 rounded-full border border-amber-600/60 text-[#FAFAFA] hover:bg-amber-500 hover:text-[#050505] transition-colors duration-300"
    >
        <Icon className="w-6 h-6" strokeWidth={1.5} />
        <span className="text-left leading-tight">
            <span className="block text-[10px] uppercase tracking-[0.2em] opacity-70">{top}</span>
            <span className="block text-sm font-semibold">{bottom}</span>
        </span>
    </a>
);

export default function AppDownload() {
    return (
        <section id="app" data-testid="app-download-section" className="relative py-24 sm:py-32 bg-[#0A0A0A] border-y border-white/5 overflow-hidden">
            <div className="absolute -bottom-24 -right-24 w-[36rem] h-[36rem] gold-glow pointer-events-none" />
            <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
                <Reveal className="lg:col-span-6 order-2 lg:order-1">
                    <div className="relative">
                        <div className="absolute -inset-8 gold-glow pointer-events-none" />
                        <div className="overflow-hidden border border-white/10" data-testid="app-image-frame">
                            <img
                                src={APP_IMG}
                                alt="A stylish person using the LookAura app on a smartphone"
                                className="w-full h-[24rem] sm:h-[28rem] object-cover"
                                loading="lazy"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/60 via-transparent to-transparent" />
                        </div>
                    </div>
                </Reveal>

                <div className="lg:col-span-6 order-1 lg:order-2">
                    <Reveal>
                        <Overline>The App</Overline>
                        <h2 className="mt-6 font-serif-display text-4xl sm:text-5xl tracking-tight text-[#FAFAFA]">
                            Your coach, <span className="italic text-amber-500">in your pocket</span>
                        </h2>
                        <p className="mt-8 text-base sm:text-lg leading-relaxed text-zinc-400 max-w-xl">
                            The full LookAura experience lives in the mobile app — upload a photo, receive your AI appearance analysis, and explore recommendations built around you.
                        </p>
                    </Reveal>
                    <Reveal delay={0.15}>
                        <div className="mt-10 flex flex-wrap gap-4">
                            <StoreButton href={APP_STORE_URL} testId="app-store-button" icon={Apple} top="Download on the" bottom="App Store" />
                            <StoreButton href={GOOGLE_PLAY_URL} testId="google-play-button" icon={Play} top="Get it on" bottom="Google Play" />
                        </div>
                        <p className="mt-5 text-xs font-mono-accent text-zinc-500" data-testid="store-links-placeholder-note">
                            Placeholder links — replace with the live App Store and Google Play listings.
                        </p>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
